// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fleetbot-root {
  --fb-radius: 12px;
  --fb-shadow: 0 10px 30px rgba(24, 39, 57, 0.18);
  font-family: Inter, sans-serif;
  pointer-events: none;
}

.fleetbot-fab {
  overflow: visible !important;
  pointer-events: auto;
}

.fleetbot-fab-ring {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  box-shadow: 0 0 0 0 rgba(30, 114, 184, 0.4);
  animation: fleetbotFabPing 2.4s ease-out infinite;
}

.fleetbot-fab svg {
  position: relative;
  z-index: 1;
  animation: fleetbotFabIcon 3.4s ease-in-out infinite;
}

.fleetbot-fab:hover,
.fleetbot-fab:focus-visible {
  transform: translateY(-3px) scale(1.05);
}

.fleetbot-fab.is-open .fleetbot-fab-ring,
.fleetbot-fab.is-open svg {
  animation: none;
}

.fleetbot-panel {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 9994;
  width: 380px;
  max-width: calc(100vw - 24px);
  height: 540px;
  max-height: calc(100vh - 140px);
  border-radius: var(--fb-radius) !important;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}

.fleetbot-panel.is-open {
  pointer-events: auto;
}

.fleetbot-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  min-height: 56px;
}

.fleetbot-header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.fleetbot-header-title strong {
  display: block;
  font-size: 14px;
  line-height: 1.2;
}

.fleetbot-header-sub {
  font-size: 11px;
  opacity: 0.8;
}

.fleetbot-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: fleetbotAvatarPulse 2.8s ease-in-out infinite;
}

.fleetbot-icon-btn {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 12px;
  font-family: inherit;
  transition: background 160ms ease, transform 160ms ease, opacity 160ms ease;
}

.fleetbot-icon-btn.is-light {
  color: var(--fb-text);
  background: rgba(48, 58, 73, 0.06);
}

.fleetbot-icon-btn:hover {
  opacity: 1;
  transform: translateY(-1px);
}

.fleetbot-icon-btn:active {
  transform: scale(0.96);
}

.fleetbot-nav {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
}

.fleetbot-crumbs {
  flex: 1 1;
  min-width: 0;
  font-size: 11px;
  color: var(--fb-text);
  opacity: 0.75;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fleetbot-crumb-sep {
  margin: 0 4px;
  opacity: 0.6;
}

.fleetbot-body {
  flex: 1 1;
  overflow: auto;
  padding: 14px 12px 16px;
}

.fleetbot-bubble {
  background: rgba(30, 114, 184, 0.08);
  border-radius: 10px 10px 10px 4px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  margin-bottom: 12px;
  animation: fleetbotBubbleIn 0.42s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-choices {
  display: flex;
  flex-direction: column;
}

.fleetbot-choice {
  animation: fleetbotRise 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-choices .fleetbot-choice:nth-child(1) {
  animation-delay: 0.04s;
}

.fleetbot-choices .fleetbot-choice:nth-child(2) {
  animation-delay: 0.08s;
}

.fleetbot-choices .fleetbot-choice:nth-child(3) {
  animation-delay: 0.12s;
}

.fleetbot-choices .fleetbot-choice:nth-child(4) {
  animation-delay: 0.16s;
}

.fleetbot-choices .fleetbot-choice:nth-child(5) {
  animation-delay: 0.2s;
}

.fleetbot-choices .fleetbot-choice:nth-child(6) {
  animation-delay: 0.24s;
}

.fleetbot-choices .fleetbot-choice:nth-child(7) {
  animation-delay: 0.28s;
}

.fleetbot-choices .fleetbot-choice:nth-child(8) {
  animation-delay: 0.32s;
}

.fleetbot-choices .fleetbot-choice:nth-child(n+9) {
  animation-delay: 0.36s;
}

.fleetbot-choice:hover {
  transform: translateX(4px);
}

.fleetbot-search {
  animation: fleetbotRise 0.32s ease both;
}

.fleetbot-status,
.fleetbot-empty,
.fleetbot-error,
.fleetbot-empty-inline {
  text-align: center;
  font-size: 13px;
  padding: 24px 12px;
  color: rgba(48, 58, 73, 0.72);
  animation: fleetbotRise 0.35s ease both;
}

.fleetbot-error p {
  margin: 0 0 12px;
}

.fleetbot-dots {
  display: inline-flex;
  gap: 4px;
  margin-right: 8px;
}

.fleetbot-dots i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--fb-accent);
  animation: fleetbotPulse 1s infinite ease-in-out;
}

.fleetbot-dots i:nth-child(2) {
  animation-delay: 0.16s;
}

.fleetbot-dots i:nth-child(3) {
  animation-delay: 0.32s;
}

@keyframes fleetbotPulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-3px);
  }
}
.fleetbot-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  gap: 8px;
  margin-bottom: 12px;
}

.fleetbot-summary {
  display: grid;
  grid-gap: 10px;
  gap: 10px;
}

.fleetbot-summary-hero {
  background: rgba(30, 114, 184, 0.1);
  border-radius: 10px;
  padding: 14px 12px 12px;
  animation: fleetbotRise 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-summary-hero-value {
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
  animation: fleetbotCountPop 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-summary-kicker {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 6px;
}

.fleetbot-summary-hero-label {
  font-size: 13px;
  font-weight: 600;
  margin-top: 4px;
}

.fleetbot-summary-meter {
  margin-top: 10px;
}

.fleetbot-summary-hint {
  margin-top: 6px;
  font-size: 11px;
  opacity: 0.75;
}

.fleetbot-stat {
  background: rgba(128, 128, 128, 0.12);
  border-radius: 8px;
  padding: 10px;
  animation: fleetbotRise 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-stats .fleetbot-stat:nth-child(1) {
  animation-delay: 0.05s;
}

.fleetbot-stats .fleetbot-stat:nth-child(2) {
  animation-delay: 0.1s;
}

.fleetbot-stats .fleetbot-stat:nth-child(3) {
  animation-delay: 0.15s;
}

.fleetbot-stats .fleetbot-stat:nth-child(4) {
  animation-delay: 0.2s;
}

.fleetbot-stat.is-accent {
  background: rgba(30, 114, 184, 0.1);
}

.fleetbot-stat-label {
  font-size: 11px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.fleetbot-stat-label > span:first-child {
  opacity: 0.7;
}

.fleetbot-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  opacity: 0.85;
  cursor: pointer;
  line-height: 0;
}

.fleetbot-info-btn svg {
  font-size: 14px;
}

.fleetbot-info-tip {
  font-size: 12px;
  line-height: 1.45;
  min-width: 150px;
}

.fleetbot-info-tip-block + .fleetbot-info-tip-block {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.fleetbot-info-tip strong {
  display: block;
  margin-bottom: 2px;
}

.fleetbot-stat-value {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
}

.fleetbot-stat-hint {
  margin-top: 4px;
  font-size: 11px;
  opacity: 0.7;
}

.fleetbot-list {
  display: grid;
  grid-gap: 8px;
  gap: 8px;
}

.fleetbot-row,
.fleetbot-card {
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 8px;
  padding: 10px;
  background: transparent;
  animation: fleetbotRise 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-list .fleetbot-card:nth-child(1),
.fleetbot-list .fleetbot-row:nth-child(1),
.fleetbot-list .fleetbot-meter-row:nth-child(1) {
  animation-delay: 0.04s;
}

.fleetbot-list .fleetbot-card:nth-child(2),
.fleetbot-list .fleetbot-row:nth-child(2),
.fleetbot-list .fleetbot-meter-row:nth-child(2) {
  animation-delay: 0.08s;
}

.fleetbot-list .fleetbot-card:nth-child(3),
.fleetbot-list .fleetbot-row:nth-child(3),
.fleetbot-list .fleetbot-meter-row:nth-child(3) {
  animation-delay: 0.12s;
}

.fleetbot-list .fleetbot-card:nth-child(4),
.fleetbot-list .fleetbot-row:nth-child(4),
.fleetbot-list .fleetbot-meter-row:nth-child(4) {
  animation-delay: 0.16s;
}

.fleetbot-list .fleetbot-card:nth-child(5),
.fleetbot-list .fleetbot-row:nth-child(5),
.fleetbot-list .fleetbot-meter-row:nth-child(5) {
  animation-delay: 0.2s;
}

.fleetbot-list .fleetbot-card:nth-child(n+6),
.fleetbot-list .fleetbot-row:nth-child(n+6),
.fleetbot-list .fleetbot-meter-row:nth-child(n+6) {
  animation-delay: 0.24s;
}

.fleetbot-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.fleetbot-row-title,
.fleetbot-card-title {
  font-size: 13px;
  font-weight: 600;
}

.fleetbot-card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.fleetbot-row-meta {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 3px;
}

.fleetbot-row-side {
  text-align: right;
  flex-shrink: 0;
}

.fleetbot-row-value {
  font-size: 12px;
  font-weight: 600;
}

.fleetbot-badge {
  display: inline-block;
  margin-top: 4px;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(48, 58, 73, 0.08);
}

.fleetbot-badge.is-ok {
  background: rgba(75, 181, 67, 0.16);
  color: #2e7d32;
}

.fleetbot-badge.is-warn,
.fleetbot-card.is-warn {
  background: rgba(255, 66, 76, 0.08);
  color: var(--fb-error);
}

.fleetbot-card.is-warn {
  color: var(--fb-text);
  border-color: rgba(255, 66, 76, 0.2);
}

.fleetbot-section-title {
  font-size: 12px;
  font-weight: 600;
  margin: 4px 0 8px;
}

.fleetbot-vehicle-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
}

.fleetbot-kv {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  margin-top: 6px;
}

.fleetbot-kv span {
  opacity: 0.7;
}

.fleetbot-compare {
  margin-top: 8px;
}

.fleetbot-compare-bar {
  display: flex;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: #eef1f4;
}

.fleetbot-compare-bar > * {
  height: 100%;
  transform-origin: left center;
  animation: fleetbotGrowX 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-compare-bar .is-spent {
  background: var(--fb-accent);
}

.fleetbot-compare-bar .is-saved {
  background: var(--fb-green);
}

.fleetbot-compare-bar .is-pending {
  background: #f0ad2e;
}

.fleetbot-compare-legend {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 6px;
  font-size: 11px;
}

.fleetbot-compare-legend .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

.fleetbot-compare-legend .dot.is-spent {
  background: var(--fb-accent);
}

.fleetbot-compare-legend .dot.is-saved {
  background: var(--fb-green);
}

.fleetbot-compare-legend .dot.is-pending {
  background: #f0ad2e;
}

.fleetbot-meter {
  height: 6px;
  background: #eef1f4;
  border-radius: 999px;
  overflow: hidden;
}

.fleetbot-meter span {
  display: block;
  height: 100%;
  background: var(--fb-accent);
  transform-origin: left center;
  animation: fleetbotGrowX 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-meter-row {
  animation: fleetbotRise 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fleetbot-meter-row + .fleetbot-meter-row {
  margin-top: 8px;
}

.fleetbot-meter-label {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  margin-bottom: 4px;
}

.fleetbot-result {
  animation: fleetbotRise 0.35s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes fleetbotFabPing {
  0% {
    box-shadow: 0 0 0 0 rgba(30, 114, 184, 0.42);
    opacity: 1;
  }
  70%, 100% {
    box-shadow: 0 0 0 16px rgba(30, 114, 184, 0);
    opacity: 0;
  }
}
@keyframes fleetbotFabIcon {
  0%, 68%, 100% {
    transform: rotate(0deg);
  }
  74% {
    transform: rotate(-14deg);
  }
  80% {
    transform: rotate(10deg);
  }
  86% {
    transform: rotate(-6deg);
  }
  92% {
    transform: rotate(3deg);
  }
}
@keyframes fleetbotAvatarPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}
@keyframes fleetbotBubbleIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes fleetbotRise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fleetbotGrowX {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes fleetbotCountPop {
  from {
    opacity: 0;
    transform: scale(0.86);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@media (max-width: 600px) {
  .fleetbot-fab {
    right: 14px;
    bottom: 32px;
  }
  .fleetbot-panel {
    right: 12px;
    left: 12px;
    width: auto;
    bottom: 92px;
    height: min(70vh, 560px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .fleetbot-fab-ring,
  .fleetbot-fab svg,
  .fleetbot-avatar,
  .fleetbot-bubble,
  .fleetbot-choice,
  .fleetbot-search,
  .fleetbot-status,
  .fleetbot-empty,
  .fleetbot-error,
  .fleetbot-empty-inline,
  .fleetbot-summary-hero,
  .fleetbot-summary-hero-value,
  .fleetbot-stat,
  .fleetbot-row,
  .fleetbot-card,
  .fleetbot-meter-row,
  .fleetbot-meter span,
  .fleetbot-compare-bar > *,
  .fleetbot-result,
  .fleetbot-dots i {
    animation: none !important;
  }
  .fleetbot-fab,
  .fleetbot-panel,
  .fleetbot-choice,
  .fleetbot-icon-btn {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/FleetBot/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,+CAAA;EACA,8BAAA;EACA,oBAAA;AACF;;AAEA;EACE,4BAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,oBAAA;EACA,2CAAA;EACA,iDAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,oDAAA;AACF;;AAEA;;EAEE,uCAAA;AACF;;AAEA;;EAEE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,+BAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wDAAA;AACF;;AAEA;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,2EAAA;AACF;;AAEA;EACE,qBAAA;EACA,kCAAA;AACF;;AAEA;EACE,UAAA;EACA,2BAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,iDAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,qEAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,iEAAA;AACF;;AAEA;EAAkD,sBAAA;AAElD;;AADA;EAAkD,sBAAA;AAKlD;;AAJA;EAAkD,sBAAA;AAQlD;;AAPA;EAAkD,sBAAA;AAWlD;;AAVA;EAAkD,qBAAA;AAclD;;AAbA;EAAkD,sBAAA;AAiBlD;;AAhBA;EAAkD,sBAAA;AAoBlD;;AAnBA;EAAkD,sBAAA;AAuBlD;;AAtBA;EAAsD,sBAAA;AA0BtD;;AAxBA;EACE,0BAAA;AA2BF;;AAxBA;EACE,uCAAA;AA2BF;;AAxBA;;;;EAIE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,uCAAA;AA2BF;;AAxBA;EACE,gBAAA;AA2BF;;AAxBA;EACE,oBAAA;EACA,QAAA;EACA,iBAAA;AA2BF;;AAxBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,gDAAA;AA2BF;;AAxBA;EACE,sBAAA;AA2BF;;AAxBA;EACE,sBAAA;AA2BF;;AAxBA;EACE;IAGE,YAAA;IACA,wBAAA;EAyBF;EAvBA;IACE,UAAA;IACA,2BAAA;EAyBF;AACF;AAtBA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EAAA,QAAA;EACA,mBAAA;AAwBF;;AArBA;EACE,aAAA;EACA,cAAA;EAAA,SAAA;AAwBF;;AArBA;EACE,mCAAA;EACA,mBAAA;EACA,uBAAA;EACA,gEAAA;AAwBF;;AArBA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oEAAA;AAwBF;;AArBA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAwBF;;AArBA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAwBF;;AArBA;EACE,gBAAA;AAwBF;;AArBA;EACE,eAAA;EACA,eAAA;EACA,aAAA;AAwBF;;AArBA;EACE,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,gEAAA;AAwBF;;AArBA;EAA8C,sBAAA;AAyB9C;;AAxBA;EAA8C,qBAAA;AA4B9C;;AA3BA;EAA8C,sBAAA;AA+B9C;;AA9BA;EAA8C,qBAAA;AAkC9C;;AAhCA;EACE,mCAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAmCF;;AAhCA;EACE,YAAA;AAmCF;;AAhCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AAmCF;;AAhCA;EACE,eAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,gBAAA;EACA,8CAAA;AAmCF;;AAhCA;EACE,cAAA;EACA,kBAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,eAAA;EACA,YAAA;AAmCF;;AAhCA;EACE,aAAA;EACA,aAAA;EAAA,QAAA;AAmCF;;AAhCA;;EAEE,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,iEAAA;AAmCF;;AAhCA;;;EAEkD,sBAAA;AAoClD;;AAnCA;;;EAEkD,sBAAA;AAuClD;;AAtCA;;;EAEkD,sBAAA;AA0ClD;;AAzCA;;;EAEkD,sBAAA;AA6ClD;;AA5CA;;;EAEkD,qBAAA;AAgDlD;;AA/CA;;;EAEsD,sBAAA;AAmDtD;;AAjDA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAoDF;;AAjDA;;EAEE,eAAA;EACA,gBAAA;AAoDF;;AAjDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAoDF;;AAjDA;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAoDF;;AAjDA;EACE,iBAAA;EACA,cAAA;AAoDF;;AAjDA;EACE,eAAA;EACA,gBAAA;AAoDF;;AAjDA;EACE,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kCAAA;AAoDF;;AAjDA;EACE,mCAAA;EACA,cAAA;AAoDF;;AAjDA;;EAEE,mCAAA;EACA,sBAAA;AAoDF;;AAjDA;EACE,qBAAA;EACA,oCAAA;AAoDF;;AAjDA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAoDF;;AAjDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAoDF;;AAjDA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAoDF;;AAjDA;EACE,YAAA;AAoDF;;AAjDA;EACE,eAAA;AAoDF;;AAjDA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAoDF;;AAjDA;EACE,YAAA;EACA,6BAAA;EACA,iEAAA;AAoDF;;AAjDA;EACE,4BAAA;AAoDF;;AAjDA;EACE,2BAAA;AAoDF;;AAjDA;EACE,mBAAA;AAoDF;;AAjDA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAoDF;;AAjDA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAoDF;;AAjDA;EACE,4BAAA;AAoDF;;AAjDA;EACE,2BAAA;AAoDF;;AAjDA;EACE,mBAAA;AAoDF;;AAjDA;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAoDF;;AAjDA;EACE,cAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,iEAAA;AAoDF;;AAjDA;EACE,iEAAA;AAoDF;;AAjDA;EACE,eAAA;AAoDF;;AAjDA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAoDF;;AAjDA;EACE,iEAAA;AAoDF;;AAjDA;EACE;IACE,4CAAA;IACA,UAAA;EAoDF;EAlDA;IAEE,4CAAA;IACA,UAAA;EAmDF;AACF;AAhDA;EACE;IAGE,uBAAA;EAgDF;EA9CA;IACE,yBAAA;EAgDF;EA9CA;IACE,wBAAA;EAgDF;EA9CA;IACE,wBAAA;EAgDF;EA9CA;IACE,uBAAA;EAgDF;AACF;AA7CA;EACE;IAEE,mBAAA;EA8CF;EA5CA;IACE,sBAAA;EA8CF;AACF;AA3CA;EACE;IACE,UAAA;IACA,sCAAA;EA6CF;EA3CA;IACE,UAAA;IACA,eAAA;EA6CF;AACF;AA1CA;EACE;IACE,UAAA;IACA,2BAAA;EA4CF;EA1CA;IACE,UAAA;IACA,wBAAA;EA4CF;AACF;AAzCA;EACE;IACE,oBAAA;EA2CF;EAzCA;IACE,oBAAA;EA2CF;AACF;AAxCA;EACE;IACE,UAAA;IACA,sBAAA;EA0CF;EAxCA;IACE,UAAA;IACA,mBAAA;EA0CF;AACF;AAvCA;EACE;IACE,WAAA;IACA,YAAA;EAyCF;EAtCA;IACE,WAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,wBAAA;EAwCF;AACF;AArCA;EACE;;;;;;;;;;;;;;;;;;;;IAoBE,0BAAA;EAuCF;EApCA;;;;IAIE,gBAAA;EAsCF;AACF","sourcesContent":[".fleetbot-root {\n  --fb-radius: 12px;\n  --fb-shadow: 0 10px 30px rgba(24, 39, 57, 0.18);\n  font-family: Inter, sans-serif;\n  pointer-events: none;\n}\n\n.fleetbot-fab {\n  overflow: visible !important;\n  pointer-events: auto;\n}\n\n.fleetbot-fab-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  pointer-events: none;\n  box-shadow: 0 0 0 0 rgba(30, 114, 184, 0.4);\n  animation: fleetbotFabPing 2.4s ease-out infinite;\n}\n\n.fleetbot-fab svg {\n  position: relative;\n  z-index: 1;\n  animation: fleetbotFabIcon 3.4s ease-in-out infinite;\n}\n\n.fleetbot-fab:hover,\n.fleetbot-fab:focus-visible {\n  transform: translateY(-3px) scale(1.05);\n}\n\n.fleetbot-fab.is-open .fleetbot-fab-ring,\n.fleetbot-fab.is-open svg {\n  animation: none;\n}\n\n.fleetbot-panel {\n  position: fixed;\n  right: 20px;\n  bottom: 100px;\n  z-index: 9994;\n  width: 380px;\n  max-width: calc(100vw - 24px);\n  height: 540px;\n  max-height: calc(100vh - 140px);\n  border-radius: var(--fb-radius) !important;\n  display: flex;\n  flex-direction: column;\n  pointer-events: none;\n}\n\n.fleetbot-panel.is-open {\n  pointer-events: auto;\n}\n\n.fleetbot-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  min-height: 56px;\n}\n\n.fleetbot-header-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.fleetbot-header-title strong {\n  display: block;\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.fleetbot-header-sub {\n  font-size: 11px;\n  opacity: 0.8;\n}\n\n.fleetbot-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.14);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  animation: fleetbotAvatarPulse 2.8s ease-in-out infinite;\n}\n\n.fleetbot-icon-btn {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 6px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-family: inherit;\n  transition: background 160ms ease, transform 160ms ease, opacity 160ms ease;\n}\n\n.fleetbot-icon-btn.is-light {\n  color: var(--fb-text);\n  background: rgba(48, 58, 73, 0.06);\n}\n\n.fleetbot-icon-btn:hover {\n  opacity: 1;\n  transform: translateY(-1px);\n}\n\n.fleetbot-icon-btn:active {\n  transform: scale(0.96);\n}\n\n.fleetbot-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border-bottom: 1px solid rgba(128, 128, 128, 0.2);\n}\n\n.fleetbot-crumbs {\n  flex: 1;\n  min-width: 0;\n  font-size: 11px;\n  color: var(--fb-text);\n  opacity: 0.75;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fleetbot-crumb-sep {\n  margin: 0 4px;\n  opacity: 0.6;\n}\n\n.fleetbot-body {\n  flex: 1;\n  overflow: auto;\n  padding: 14px 12px 16px;\n}\n\n.fleetbot-bubble {\n  background: rgba(30, 114, 184, 0.08);\n  border-radius: 10px 10px 10px 4px;\n  padding: 10px 12px;\n  font-size: 13px;\n  line-height: 1.45;\n  margin-bottom: 12px;\n  animation: fleetbotBubbleIn 0.42s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-choices {\n  display: flex;\n  flex-direction: column;\n}\n\n.fleetbot-choice {\n  animation: fleetbotRise 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-choices .fleetbot-choice:nth-child(1) { animation-delay: 0.04s; }\n.fleetbot-choices .fleetbot-choice:nth-child(2) { animation-delay: 0.08s; }\n.fleetbot-choices .fleetbot-choice:nth-child(3) { animation-delay: 0.12s; }\n.fleetbot-choices .fleetbot-choice:nth-child(4) { animation-delay: 0.16s; }\n.fleetbot-choices .fleetbot-choice:nth-child(5) { animation-delay: 0.2s; }\n.fleetbot-choices .fleetbot-choice:nth-child(6) { animation-delay: 0.24s; }\n.fleetbot-choices .fleetbot-choice:nth-child(7) { animation-delay: 0.28s; }\n.fleetbot-choices .fleetbot-choice:nth-child(8) { animation-delay: 0.32s; }\n.fleetbot-choices .fleetbot-choice:nth-child(n + 9) { animation-delay: 0.36s; }\n\n.fleetbot-choice:hover {\n  transform: translateX(4px);\n}\n\n.fleetbot-search {\n  animation: fleetbotRise 0.32s ease both;\n}\n\n.fleetbot-status,\n.fleetbot-empty,\n.fleetbot-error,\n.fleetbot-empty-inline {\n  text-align: center;\n  font-size: 13px;\n  padding: 24px 12px;\n  color: rgba(48, 58, 73, 0.72);\n  animation: fleetbotRise 0.35s ease both;\n}\n\n.fleetbot-error p {\n  margin: 0 0 12px;\n}\n\n.fleetbot-dots {\n  display: inline-flex;\n  gap: 4px;\n  margin-right: 8px;\n}\n\n.fleetbot-dots i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--fb-accent);\n  animation: fleetbotPulse 1s infinite ease-in-out;\n}\n\n.fleetbot-dots i:nth-child(2) {\n  animation-delay: 0.16s;\n}\n\n.fleetbot-dots i:nth-child(3) {\n  animation-delay: 0.32s;\n}\n\n@keyframes fleetbotPulse {\n  0%,\n  80%,\n  100% {\n    opacity: 0.3;\n    transform: translateY(0);\n  }\n  40% {\n    opacity: 1;\n    transform: translateY(-3px);\n  }\n}\n\n.fleetbot-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.fleetbot-summary {\n  display: grid;\n  gap: 10px;\n}\n\n.fleetbot-summary-hero {\n  background: rgba(30, 114, 184, 0.1);\n  border-radius: 10px;\n  padding: 14px 12px 12px;\n  animation: fleetbotRise 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-summary-hero-value {\n  font-size: 28px;\n  font-weight: 800;\n  line-height: 1.1;\n  animation: fleetbotCountPop 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-summary-kicker {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  opacity: 0.7;\n  margin-bottom: 6px;\n}\n\n.fleetbot-summary-hero-label {\n  font-size: 13px;\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n.fleetbot-summary-meter {\n  margin-top: 10px;\n}\n\n.fleetbot-summary-hint {\n  margin-top: 6px;\n  font-size: 11px;\n  opacity: 0.75;\n}\n\n.fleetbot-stat {\n  background: rgba(128, 128, 128, 0.12);\n  border-radius: 8px;\n  padding: 10px;\n  animation: fleetbotRise 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-stats .fleetbot-stat:nth-child(1) { animation-delay: 0.05s; }\n.fleetbot-stats .fleetbot-stat:nth-child(2) { animation-delay: 0.1s; }\n.fleetbot-stats .fleetbot-stat:nth-child(3) { animation-delay: 0.15s; }\n.fleetbot-stats .fleetbot-stat:nth-child(4) { animation-delay: 0.2s; }\n\n.fleetbot-stat.is-accent {\n  background: rgba(30, 114, 184, 0.1);\n}\n\n.fleetbot-stat-label {\n  font-size: 11px;\n  margin-bottom: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.fleetbot-stat-label > span:first-child {\n  opacity: 0.7;\n}\n\n.fleetbot-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: inherit;\n  opacity: 0.85;\n  cursor: pointer;\n  line-height: 0;\n}\n\n.fleetbot-info-btn svg {\n  font-size: 14px;\n}\n\n.fleetbot-info-tip {\n  font-size: 12px;\n  line-height: 1.45;\n  min-width: 150px;\n}\n\n.fleetbot-info-tip-block + .fleetbot-info-tip-block {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.fleetbot-info-tip strong {\n  display: block;\n  margin-bottom: 2px;\n}\n\n.fleetbot-stat-value {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.fleetbot-stat-hint {\n  margin-top: 4px;\n  font-size: 11px;\n  opacity: 0.7;\n}\n\n.fleetbot-list {\n  display: grid;\n  gap: 8px;\n}\n\n.fleetbot-row,\n.fleetbot-card {\n  border: 1px solid rgba(128, 128, 128, 0.2);\n  border-radius: 8px;\n  padding: 10px;\n  background: transparent;\n  animation: fleetbotRise 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-list .fleetbot-card:nth-child(1),\n.fleetbot-list .fleetbot-row:nth-child(1),\n.fleetbot-list .fleetbot-meter-row:nth-child(1) { animation-delay: 0.04s; }\n.fleetbot-list .fleetbot-card:nth-child(2),\n.fleetbot-list .fleetbot-row:nth-child(2),\n.fleetbot-list .fleetbot-meter-row:nth-child(2) { animation-delay: 0.08s; }\n.fleetbot-list .fleetbot-card:nth-child(3),\n.fleetbot-list .fleetbot-row:nth-child(3),\n.fleetbot-list .fleetbot-meter-row:nth-child(3) { animation-delay: 0.12s; }\n.fleetbot-list .fleetbot-card:nth-child(4),\n.fleetbot-list .fleetbot-row:nth-child(4),\n.fleetbot-list .fleetbot-meter-row:nth-child(4) { animation-delay: 0.16s; }\n.fleetbot-list .fleetbot-card:nth-child(5),\n.fleetbot-list .fleetbot-row:nth-child(5),\n.fleetbot-list .fleetbot-meter-row:nth-child(5) { animation-delay: 0.2s; }\n.fleetbot-list .fleetbot-card:nth-child(n + 6),\n.fleetbot-list .fleetbot-row:nth-child(n + 6),\n.fleetbot-list .fleetbot-meter-row:nth-child(n + 6) { animation-delay: 0.24s; }\n\n.fleetbot-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.fleetbot-row-title,\n.fleetbot-card-title {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.fleetbot-card-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.fleetbot-row-meta {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-top: 3px;\n}\n\n.fleetbot-row-side {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.fleetbot-row-value {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.fleetbot-badge {\n  display: inline-block;\n  margin-top: 4px;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: rgba(48, 58, 73, 0.08);\n}\n\n.fleetbot-badge.is-ok {\n  background: rgba(75, 181, 67, 0.16);\n  color: #2e7d32;\n}\n\n.fleetbot-badge.is-warn,\n.fleetbot-card.is-warn {\n  background: rgba(255, 66, 76, 0.08);\n  color: var(--fb-error);\n}\n\n.fleetbot-card.is-warn {\n  color: var(--fb-text);\n  border-color: rgba(255, 66, 76, 0.2);\n}\n\n.fleetbot-section-title {\n  font-size: 12px;\n  font-weight: 600;\n  margin: 4px 0 8px;\n}\n\n.fleetbot-vehicle-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n  font-size: 13px;\n}\n\n.fleetbot-kv {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.fleetbot-kv span {\n  opacity: 0.7;\n}\n\n.fleetbot-compare {\n  margin-top: 8px;\n}\n\n.fleetbot-compare-bar {\n  display: flex;\n  height: 10px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #eef1f4;\n}\n\n.fleetbot-compare-bar > * {\n  height: 100%;\n  transform-origin: left center;\n  animation: fleetbotGrowX 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-compare-bar .is-spent {\n  background: var(--fb-accent);\n}\n\n.fleetbot-compare-bar .is-saved {\n  background: var(--fb-green);\n}\n\n.fleetbot-compare-bar .is-pending {\n  background: #f0ad2e;\n}\n\n.fleetbot-compare-legend {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 6px;\n  font-size: 11px;\n}\n\n.fleetbot-compare-legend .dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 6px;\n}\n\n.fleetbot-compare-legend .dot.is-spent {\n  background: var(--fb-accent);\n}\n\n.fleetbot-compare-legend .dot.is-saved {\n  background: var(--fb-green);\n}\n\n.fleetbot-compare-legend .dot.is-pending {\n  background: #f0ad2e;\n}\n\n.fleetbot-meter {\n  height: 6px;\n  background: #eef1f4;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.fleetbot-meter span {\n  display: block;\n  height: 100%;\n  background: var(--fb-accent);\n  transform-origin: left center;\n  animation: fleetbotGrowX 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-meter-row {\n  animation: fleetbotRise 0.38s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fleetbot-meter-row + .fleetbot-meter-row {\n  margin-top: 8px;\n}\n\n.fleetbot-meter-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  margin-bottom: 4px;\n}\n\n.fleetbot-result {\n  animation: fleetbotRise 0.35s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes fleetbotFabPing {\n  0% {\n    box-shadow: 0 0 0 0 rgba(30, 114, 184, 0.42);\n    opacity: 1;\n  }\n  70%,\n  100% {\n    box-shadow: 0 0 0 16px rgba(30, 114, 184, 0);\n    opacity: 0;\n  }\n}\n\n@keyframes fleetbotFabIcon {\n  0%,\n  68%,\n  100% {\n    transform: rotate(0deg);\n  }\n  74% {\n    transform: rotate(-14deg);\n  }\n  80% {\n    transform: rotate(10deg);\n  }\n  86% {\n    transform: rotate(-6deg);\n  }\n  92% {\n    transform: rotate(3deg);\n  }\n}\n\n@keyframes fleetbotAvatarPulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.08);\n  }\n}\n\n@keyframes fleetbotBubbleIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes fleetbotRise {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fleetbotGrowX {\n  from {\n    transform: scaleX(0);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n\n@keyframes fleetbotCountPop {\n  from {\n    opacity: 0;\n    transform: scale(0.86);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 600px) {\n  .fleetbot-fab {\n    right: 14px;\n    bottom: 32px;\n  }\n\n  .fleetbot-panel {\n    right: 12px;\n    left: 12px;\n    width: auto;\n    bottom: 92px;\n    height: min(70vh, 560px);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fleetbot-fab-ring,\n  .fleetbot-fab svg,\n  .fleetbot-avatar,\n  .fleetbot-bubble,\n  .fleetbot-choice,\n  .fleetbot-search,\n  .fleetbot-status,\n  .fleetbot-empty,\n  .fleetbot-error,\n  .fleetbot-empty-inline,\n  .fleetbot-summary-hero,\n  .fleetbot-summary-hero-value,\n  .fleetbot-stat,\n  .fleetbot-row,\n  .fleetbot-card,\n  .fleetbot-meter-row,\n  .fleetbot-meter span,\n  .fleetbot-compare-bar > *,\n  .fleetbot-result,\n  .fleetbot-dots i {\n    animation: none !important;\n  }\n\n  .fleetbot-fab,\n  .fleetbot-panel,\n  .fleetbot-choice,\n  .fleetbot-icon-btn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
